module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


/*****************
 ** WEBPACK FOOTER
 ** external "sjcl"
 ** module id = 1
 ** module chunks = 0
 **/